// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1Ecr6","title":"Images45_title__ozAts","images":"Images45_images__2EDQY"};